import React, { useEffect, useState } from 'react'
import { Builder, BuilderComponent, builder } from '@builder.io/react'
import PropTypes from 'prop-types'
import { useFetchAPI } from 'hooks'
import '@builder.io/widgets'

// Determine the API key based on the URL
const builderPublicApiKey =
  window.location.hostname === 'www.alomoves.com'
    ? '7ae91e2100c441348821b5902d6e5194'
    : '61e2402350ce4c0cbc02c5526b936de4'

// Init builder.io with the appropriate key
builder.init(builderPublicApiKey)

const BuilderSection = ({ user, eventName, builderModelname, data: config }) => {
  
  const url = config.fetchDataFrom
  const [{ data }] = url
    ? useFetchAPI(url?.replace('/api/v2', ''))
    : [{ data: { ...config } }]
  
    const [content, setContent] = useState(null)

  useEffect(() => {
    const userAttributes = user.urlPath ? { urlPath: user.urlPath } : {}

    builder
      .get(builderModelname, { userAttributes })
      .toPromise()
      .then((fetchedContent) => setContent(fetchedContent))
      .catch((error) => console.error('Error fetching Builder data:', error))
  }, [builderModelname, user])

  const transformData = (data) => {
    if (
      builderModelname === 'category-pill-listing' &&
      Array.isArray(data)
    ) {
      return data.map((item) => ({
        buttonTitle: item.categoryName,
        buttonLink: `/class-finder?styles=${item.categorySlug}&order=date`
      }))
    }
    return data
  }

  return (
    <div>
      {content ? (
        <BuilderComponent
          model={builderModelname}
          content={content}
          {...(data && {
            data: { data: transformData(data), gaEventName: eventName }
          })}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  )
}

BuilderSection.propTypes = {
  user: PropTypes.object.isRequired,
  builderModelname: PropTypes.string.isRequired,
  data: PropTypes.object
}

BuilderSection.defaultProps = {
  user: {},
  data: {}
}

export default BuilderSection
